// Photo filenames for Holiday Party 2006
const HOLIDAY_PARTY_2006 = [
  'x0632_51814167122_c.jpg',
  'x0633_51814167097_c.jpg',
  'x0646_51815127301_c.jpg',
  'x0657_51815469649_l.jpg',
  'x0658_51815843170_c.jpg',
  'x0664_51814167017_c.jpg',
  'mvc-279s_51815231108_z.jpg',
  'x0601_51815843310_z.jpg',
  'x0604_51815469769_z.jpg',
  'x0617_51814167132_s.jpg',
  'x0624_51815231028_z.jpg',
  'x0626_51815127351_z.jpg',
];

export default HOLIDAY_PARTY_2006;
